export enum AvailableTabs {
    Search = 0,
    About = 1,
    // Report = 2,
}
